var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        ref: "track",
        staticClass: "ncLogin local-nc-track",
        on: {
          mousedown: function($event) {
            $event.preventDefault()
            return _vm.startDrag.apply(null, arguments)
          },
          touchstart: function($event) {
            $event.preventDefault()
            return _vm.startDrag.apply(null, arguments)
          }
        }
      },
      [
        _c("div", {
          staticClass: "local-nc-bg",
          style: { width: _vm.offsetX + _vm.handleWidth + "px" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "local-nc-text" }, [
          _vm._v(_vm._s(_vm.passed ? "验证通过" : "请按住滑块，拖动到最右边"))
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "local-nc-handle",
            class: { passed: _vm.passed },
            style: { transform: "translateX(" + _vm.offsetX + "px)" }
          },
          [_vm._v("\n      " + _vm._s(_vm.passed ? "✓" : ">") + "\n    ")]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a8ce7c7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8ce7c7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/slidingValidation.vue
// module id = null
// module chunks = 